export default __webpack_public_path__ + "i18n/es.7bf905b0f58f55ab8826ad5c749a2510.json";